import { render, staticRenderFns } from "./BCKeyAssignmentGeneral.vue?vue&type=template&id=83cedca8"
import script from "./BCKeyAssignmentGeneral.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports